/**
 * Decode JWT payload without verifying the signature (AC-24).
 * Used only to read claims such as `exp` for local session metadata.
 */
export function parseJwtPayload(token: string): Record<string, unknown> | null {
  if (!token || typeof token !== 'string') {
    return null;
  }
  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const json = decodeURIComponent(
      atob(padded)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/** Returns exp claim as epoch milliseconds, or null if missing/unreadable. */
export function expiresAtFromAccessToken(token: string): number | null {
  const payload = parseJwtPayload(token);
  const exp = payload?.exp;
  if (typeof exp !== 'number' || !isFinite(exp)) {
    return null;
  }
  return exp * 1000;
}
